import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetProjectDocumentDataRequest,
  GetProjectDocumentDataResponse,
  GetProjectDocumentJSONRequest,
  GetProjectDocumentJSONResponse,
  SendCopyDocRequest,
  SendCopyDocResponse,
} from "../../models/ProjectDocument.model";

const API_URL = environment.apiUrl;

export const getProjectDocumentData = createAsyncThunk<
  GetProjectDocumentDataResponse,
  GetProjectDocumentDataRequest
>("document/getProjectDocumentData", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Document/GetProjectDocumentData`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request),
    });
    const data: GetProjectDocumentDataResponse = await response.json();
    if (!data.success)
      return rejectWithValue(
        data.message || "Failed to fetch project document data",
      );
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message || "Unknown error");
  }
});

export const sendCopyDoc = createAsyncThunk<
  SendCopyDocResponse,
  SendCopyDocRequest
>("document/sendCopyDoc", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Document/SendCopyDoc`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request),
    });
    const data: SendCopyDocResponse = await response.json();
    if (!data.success)
      return rejectWithValue(data.message || "Failed to send copy of document");
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message || "Unknown error");
  }
});

export const getProjectDocumentJSON = createAsyncThunk<
  GetProjectDocumentJSONResponse,
  GetProjectDocumentJSONRequest
>("document/getProjectDocumentJSON", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Document/GetProjectDocumentJSON`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request),
    });
    const data: GetProjectDocumentJSONResponse = await response.json();
    if (!data.success)
      return rejectWithValue(
        data.message || "Failed to fetch project document JSON",
      );
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message || "Unknown error");
  }
});